import { useContext, useEffect, useState } from 'react'
import { useIsMounted } from '../utils/ReactUtils.js'
import { ApiGateway } from '../config/config.js'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { Box, Button, Grid2 as Grid, Paper, IconButton, MenuItem, Select} from '@mui/material'
import { getRequestConfig } from '../auth/auth.js'
import { getQuerystringParameters } from '../utils/TableUtils'
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios'
// import ConfirmDialog from '../form/ConfirmDialog.js'
import { useNavigate } from 'react-router-dom';
import RoleContext from '../auth/RoleContext.js'
import { ROLES, useRole } from '../auth/role.js'



export default function ListUsers({showFilters, setIsLoading}) {
  const navigate = useNavigate()
  const isMounted = useIsMounted()
  const roleCtx = useContext(RoleContext)
  const { hasRole } = useRole()

  // const [confirmDialog, setConfirmDialog] = useState(false)
  // const [dialogTitle, setDialogTitle] = useState("Delete this User?")
  // const [fieldErrors, setFieldErrors] = useState({})
  const [isError, setIsError] = useState(false);
  const [data, setData] = useState([])
  const [rowCount, setRowCount] = useState(0);
  const [globalFilter, setGlobalFilter] = useState('');
  const [isRefetching, setIsRefetching] = useState(false);
  // const [userToDelete, setUserToDelete] = useState("")  
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([])
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 15,
  });
  
  const [roles, setRoles] = useState('ALL')
  
  // const hideDialog = () => {
  //   setConfirmDialog(false)
  // }

  const userColumns = [
    {
      accessorKey: 'koId',
      header: 'KO ID',
      size: 10,
      editable: false,
      filterVariant: 'text'
    },
    {
      accessorKey: 'firstName',
      header: 'First Name',
      size: 20,
      editable: false,
      filterVariant: 'text',
    },
    {
      accessorKey: 'lastName',
      header: 'Last Name',
      size: 20,
      editable: false,
      filterVariant: 'text',
    },
    {
      accessorKey: 'email',
      header: 'Email',
      size: 20,
      editable: false
    },
    {
      accessorKey: 'roles',
      header: 'Roles',
      size: 20,
      editable: false,
      enableSorting: false,
      enableColumnFilter: true,
      Cell: ({row}) => {
        return row.original.roles?.map(role => {
          return role.name
        }).join(', ')
      },
      Filter: ({column}) => (
        <Select size='small' id="role_select" value={roles} onChange={handleViewSelectChange} >
          { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value="ALL">All Roles</MenuItem>}
          { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value="4,5,14">All SRA Roles</MenuItem>}
          { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value={ROLES.SRA_ADMIN.id}>{ROLES.SRA_ADMIN.name}</MenuItem>}
          { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value={ROLES.SRA_USER.id}>{ROLES.SRA_USER.name}</MenuItem>}
          { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value={ROLES.LDS_VIEWER.id}>{ROLES.LDS_VIEWER.name}</MenuItem>}
        </Select> 
      )
    },
    {
      accessorKey: 'actions',
      header: 'Actions',
      columnDefType: 'display', 
      size: 10,
      Cell: ({ row }) => (
        <Box sx={{ display: 'flex', gap: '0rem' }}>
        <Tooltip arrow placement="left" title="Edit">
          <IconButton onClick={() => {
            navigate(`/users/edit/${row.original.koId}`)
          }}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        </Box>
      )
    }
  ]

  const fetchData = async() => {
    if (!data.length) {
      setIsLoading(true)
    } else {
      setIsRefetching(true)
    }
    if (roles) {
      setIsLoading(true)
      const requestConfig = await getRequestConfig()
      let q = getQuerystringParameters({ pagination, sorting, columnFilters })
      let url = ApiGateway.employee
      try {
        if(roles !== 'ALL') {
          q += `&roles=[${roles}]`
        }
        const response = await axios.get(`${url}/search?${q}`, requestConfig )
        setData(response.data)
      } catch (error) {
        console.error(error)
      }
    }
    setIsLoading(false)
    return
  }

  // const deleteUser = async(selectedKoId) => {
  //   hideDialog()
  //   startLoading()
  //   bus.emit(Event.ALERT, { text: "Deleting Users...", style: "info", duration: 2000 })

  //   const options = {
  //     headers: {
  //       'x-api-key': ApiGateway.apiKey,
  //       'Content-Type': 'application/json',
  //       'Authorization': ApiGateway.auth
  //     }
  //   }
  //   const path = `${ApiGateway.employee}/${selectedKoId}`
  //   await axios.delete(path, options)

  //   await getUserList()
  //   stopLoading()
  //   bus.emit(Event.ALERT, { text: "User deleted", style: "success", duration: 2000 })
  // }

  const handleViewSelectChange = async (event) => {
    setRoles(event.target.value)
  }

  useEffect(() => {
    console.log('roles: ', roles)
    if(roles) {
      fetchData()
    }
  }, [roles])

  useEffect(() => {
    if (isMounted()) {
      setIsLoading(false)
    }
  },[])

  const table = useMaterialReactTable({
    // layoutMode: 'grid',
    columnFilterModeOptions: [
      'fuzzy',
      'greaterThan',
      'lessThan'
    ],
    columns: userColumns,
    data: data?.data ?? [],
    paginationDisplayMode: 'pages',
    enableColumnActions: false,
    enableColumnFilters: showFilters,
    initialState: {
      columnVisibility: { primaryKey: false },
      showColumnFilters: true
    },
    renderTopToolbar: false,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    pageCount: data.pages,
    muiToolbarAlertBannerProps: isError
      ? {
          color: 'error',
          children: 'Error loading data',
        }
      : undefined,
    // renderTopToolbarCustomActions: () => (
    //   <Tooltip arrow title="Refresh Data">
    //     <IconButton onClick={() => fetchData()}>
    //       <RefreshIcon />
    //     </IconButton>
    //   </Tooltip>
    // ),
    muiTableContainerProps: {
      sx: { minHeight: 300 }
    },
    muiTableBodyCellProps: {
      sx: {
        fontSize: '.82rem',
        padding: '4px !important'
      }
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },
  });

  useEffect(() => {
    fetchData()
  }, [
    columnFilters, 
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize, 
    sorting, 
  ])


  return (

        <>
        {/* <ConfirmDialog title={dialogTitle} text="The record will be permanently deleted" open={confirmDialog} hideDialog={hideDialog} handleConfirm={()=>deleteUser(userToDelete)} yesLabel="Delete" noLabel="Keep"/> */}
        <Paper sx={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none', width: '98%', margin: '1em auto'}}>
          <Grid container >
            {/* <Grid item size={12}>
              <Select size='small' id="role_select" value={roles} onChange={handleViewSelectChange} >
                { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value="ALL">All Roles</MenuItem>}
                { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value="4,5,14">All SRA Roles</MenuItem>}
                { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value={ROLES.SRA_ADMIN.id}>{ROLES.SRA_ADMIN.name}</MenuItem>}
                { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value={ROLES.SRA_USER.id}>{ROLES.SRA_USER.name}</MenuItem>}
                { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN]) && <MenuItem value={ROLES.LDS_VIEWER.id}>{ROLES.LDS_VIEWER.name}</MenuItem>}
              </Select>      
            </Grid> */}
            <Grid size={12}>            
              <Box sx={{marginTop: '1em'}}>
                <MaterialReactTable table={table} />
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </>
    
  )

}